import { computed } from '@vue/composition-api';
import type { ComputedRef } from '@vue/composition-api';
import { useStore } from '@/hooks/useStore';
import { LocalStorageActionTypes, LocalStorageGetterTypes } from '@/store/modules/localStorage';
import type {
  HokkaidoAirportVehicleSelection,
} from '@/models/externalReports/hokkaidoAirport/spHokkaidoAirportReport';

const LAST_VEHICLE_SELECTION_KEY = LocalStorageGetterTypes.HOKKAIDO_AIRPORT_LAST_VEHICLE_SELECTION;

interface UseLastVehicleSelectionResult {
  lastVehicleSelection: ComputedRef<HokkaidoAirportVehicleSelection | null>;
  saveLastVehicleSelection: (selection: HokkaidoAirportVehicleSelection) => void;
}

export const useLastVehicleSelection = (): UseLastVehicleSelectionResult => {
  const store = useStore();

  const lastVehicleSelection = computed<HokkaidoAirportVehicleSelection | null>(() => {
    return store.getters[LAST_VEHICLE_SELECTION_KEY] ?? null;
  });
  const saveLastVehicleSelection = (selection: HokkaidoAirportVehicleSelection): void => {
    // 開始前点検は空港名を選ばずにスキップできるため、空港名が空なら前回値を上書きしない
    if (!selection.airportName) return;
    // 車種を選ばずにスキップした場合、空港が前回と同じなら前回の車種を残す
    if (!selection.carType && selection.airportName === lastVehicleSelection.value?.airportName) return;

    store.dispatch(LocalStorageActionTypes.SET, { key: LAST_VEHICLE_SELECTION_KEY, val: selection });
  };

  return { lastVehicleSelection, saveLastVehicleSelection };
};
